import { render } from "./lotteryBetDetail.vue?vue&type=template&id=06f822dc&scoped=true"
import script from "./lotteryBetDetail.vue?vue&type=script&lang=js"
export * from "./lotteryBetDetail.vue?vue&type=script&lang=js"

import "./lotteryBetDetail.vue?vue&type=style&index=0&id=06f822dc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f822dc"]])

export default __exports__